import React, { useContext } from 'react';
import { CheckCircle, XCircle } from 'lucide-react';
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogDescription,
	DialogFooter
} from '../ui/dialog';
import { Button } from '../ui/button';
import { I18nContext } from '../../context/translations/TranslationsContext.context';

interface FeedbackModalProps {
	open: boolean;
	onClose: () => void;
	isError: boolean;
	message: string;
	title?: string;
	closeButtonText?: string;
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({
	open,
	onClose,
	isError,
	message,
	title,
	closeButtonText
}) => {
	const {
		state: { translate }
	} = useContext(I18nContext);

	const resolvedTitle =
		title || (isError ? translate('common.error') : translate('common.success'));
	const resolvedCloseText = closeButtonText || translate('common.close');

	return (
		<Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
			<DialogContent className="sm:max-w-md">
				<DialogHeader>
					<div className="flex items-center gap-3">
						{isError ? (
							<div
								data-testid="feedback-icon-error"
								className="w-10 h-10 rounded-full bg-destructive/10 flex items-center justify-center"
							>
								<XCircle className="w-5 h-5 text-destructive" />
							</div>
						) : (
							<div
								data-testid="feedback-icon-success"
								className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center"
							>
								<CheckCircle className="w-5 h-5 text-primary" />
							</div>
						)}
						<DialogTitle>{resolvedTitle}</DialogTitle>
					</div>
				</DialogHeader>
				<DialogDescription className="text-sm text-muted-foreground">{message}</DialogDescription>
				<DialogFooter>
					<Button onClick={onClose} className="rounded-full">
						{resolvedCloseText}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};

export default FeedbackModal;
